import { Overmind } from 'overmind';
import { Context } from '../index';
import { api } from '../../../services/api';

export const onInitializeOvermind = (context: Context, instance: Overmind<Context>) => {
  /* const currentDate = context.actions.date.getCurrentDateTime();

  context.state.smartLink.expirationPresets = [
    {
      label: '1 day',
      value: context.actions.smartLink.getDate({ currentDate, offset: 1, unit: 'day' }),
      selected: false,
    },
    {
      label: '2 days',
      value: context.actions.smartLink.getDate({ currentDate, offset: 2, unit: 'days' }),
      selected: false,
    },
    {
      label: '1 week',
      value: context.actions.smartLink.getDate({ currentDate, offset: 1, unit: 'week' }),
      selected: false,
    },
    {
      label: '1 month',
      value: context.actions.smartLink.getDate({ currentDate, offset: 1, unit: 'month' }),
      selected: false,
    },
  ]; */
};

export const querySmartlinkSummary = (context: Context, smartlinkId: number) => {
  const endpoint = `/api/v1/product_match/bam_links/${smartlinkId}/management/`;
  // return context.effects.api.get(endpoint).then(resp => {
  return api.get(endpoint).then(resp => {
    return Promise.resolve(resp.data.data[0]);
  });
};

export const queryAuctionPreview = (context: Context, auctionId: number) => {
  const endpoint = `/api/v1/auction_preview/`;
  const params = { a: auctionId };
  // return context.effects.api.get(endpoint, params).then(resp => {
  return api.get(endpoint, params).then(resp => {
    return Promise.resolve(resp.data.data[0].auction);
  });
};

export const updateSmartlinkSummary = (
  context: Context,
  { smartlinkId, data }: { smartlinkId: number; data: any },
) => {
  const endpoint = `/api/v1/product_match/bam_links/${smartlinkId}/management/`;
  // return context.effects.api.put(endpoint, data);
  return api.put(endpoint, data);
  // TODO: add error modal () => onError(),
};

export const getDefaultStockFields = (
  context: Context,
  { isInStock, partialFields }: { isInStock: boolean; partialFields?: any },
) => {
  const fields = partialFields || context.state.smartLink.stockStatusFields;

  return fields.map(field => {
    field.selected = field.value === isInStock;
    return field;
  });
};

export const getDefaultAuctionFields = (context: Context, participateInAuction: boolean) => {
  return context.state.smartLink.auctionStatusFields.map(field => {
    field.selected = field.value === participateInAuction;
    return field;
  });
};

export const getDate = (
  context: Context,
  { currentDate, offset, unit }: { currentDate: any; offset: any; unit: string },
) => {
  const dateObj = context.actions.date.offsetFromDate({
    originalDate: currentDate,
    number: offset,
    unit,
  });

  return context.actions.date.formatDate({ dateObj, fmt: 'MM/DD/YY' });
};

export const getLabel = (
  context: Context,
  { items, key = 'label' }: { items: any; key?: string },
) => {
  return items.find(item => item.selected)[key];
};
